import { render } from "./paginator.components.vue?vue&type=template&id=0bdde2ba&ts=true"
import script from "./paginator.components.vue?vue&type=script&lang=ts"
export * from "./paginator.components.vue?vue&type=script&lang=ts"

import exportComponent from "/home/seb/_git-wsl/inv-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__